<div class="" @fadeInAnimation>
  <div class="title-section mb-md">
    <h2 class="text-title-md-bold d-flex justify-content-between tw-w-full">
      <div class="tw-w-full">
        <p class="">Mediciones</p>
        <p class="text-info mt-xxs">Puedes registrar de forma rápida cualquier tipo de medición que necesites</p>
      </div>
    </h2>
  </div>
  <div class="templates shepherd-templates" nz-row [nzGutter]="[15, 15]">
    <div nz-col *ngFor="let template of templates; index as i" (click)="onChangeMeasurementTemplate(template, i)">
      <div class="template" [class.active]="templatesSelectedMap.has(i)">{{ template.name }}</div>
    </div>
  </div>

  <app-new-measurement @fadeInAnimation
    class="mt-xlg"
    [measurementsRow]="measurementsRowFromTemplate"
    [clinicId]="clinicId"
    [serviceId]="serviceId"
    [expertId]="expertId"
    [patientId]="patientId"
    [showBtnAction]="false"
    [showLastValue]="true"
    [required]="false"
    [showIsTemplate]="true"
    (validRow)="onAddValidRow($event)"
    (removeRow)="onRemoveRow($event)">
  </app-new-measurement>

  <div class="d-flex justify-content-end mt-md" *ngIf="this.hasUnsavedMeasurements">
    <button nz-button nzType="primary" (click)="saveBasicFormulas()">
      <i nz-icon nzType="heart" nzTheme="outline"></i>
      Guardar mediciones
    </button>
  </div>

</div>
